import * as React from "react";
import { observer } from "mobx-react";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "../TravelersHiddenInputType";
import { TravelersHiddenInputsProps } from "../typings";

export const TravelersHiddenInputs = observer(
  ({ hiddenInputType, flightSearch, hotelSearch, packageSearch }: TravelersHiddenInputsProps) => {
    switch (hiddenInputType) {
      case TRAVELERS_HIDDEN_INPUT_TYPE.FLIGHT_SEARCH:
        return (
          <input
            type="hidden"
            name="passengers"
            value={flightSearch}
            data-testid="passengers-input"
          />
        );
      case TRAVELERS_HIDDEN_INPUT_TYPE.HOTEL_SEARCH:
        return (
          <>
            <input type="hidden" name="rooms" value={hotelSearch.rooms} data-testid="rooms-input" />
            <input
              type="hidden"
              name="adults"
              value={hotelSearch.adults}
              data-testid="adults-input"
            />
            {hotelSearch.children && (
              <input
                type="hidden"
                name="children"
                value={hotelSearch.children}
                data-testid="children-input"
              />
            )}
          </>
        );
      case TRAVELERS_HIDDEN_INPUT_TYPE.PACKAGE_SEARCH:
        const packageSearchInputs = [];
        for (const key of Object.keys(packageSearch)) {
          packageSearchInputs.push(
            <input
              type="hidden"
              name={key}
              value={packageSearch[key]}
              data-testid={`${key}-input`}
            />
          );
        }

        return <>{packageSearchInputs}</>;
      default:
        return <></>;
    }
  }
);
